module.exports = __webpack_public_path__ + "static/softball-clubhouse-makeover-b57a1a772fbe5b51f0c02fd52ce98dbb.jpg";